<template>
<div class="selectMore">
    <button type="button" @click="selectBox" :name="[valName]" :value="[selectedVal]"></button>
    <div class="dim" v-show='selectBoxView'>
        <div class="botWrap selectSlide">
            <h6>{{ selectName }}</h6>
            <ul>
                <li v-for="(option, index) of options" @click="go(option);selected = option.text;$emit('input', option);selectedVal = option.value;$emit('input', option);" :key="index">
                    <button type="button">{{ option.text }}</button>
                </li>
            </ul>
            <button type="button" class="close" @click="selectBox">닫기</button>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'sortBtn',
    props: {
        selectName: String,
        options: {
            type: Array,
            required: true,            
        },
        valName: {
            type: String,
            default: null,
        },
    },
    data() {        
      return {
        selectBoxView : false,
        selected:
            this.default ? this.default : 
            this.options.length > 0 ? this.options[0] : null,
        selectedVal:
            this.default ? this.default : null,
      };
    },
    mounted() {
        this.$emit("input", this.selected); 
        this.$emit("input", this.selectedVal);    
    },
    methods: {
        selectBox: function(){
            this.selectBoxView = !this.selectBoxView;
        },
        go: function(index) {
            let add = index.value;
            this.$emit('addOn', add);
            this.selectBoxView = !this.selectBoxView;
        }
    },
};
</script>